import { h } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./ProgressIndicatorIcon.module.css";

interface ProgressIndicatorIconProps {
    class?: string;
    progress: number;
}

export default function ProgressIndicatorIcon({ class: cssClass, progress }: ProgressIndicatorIconProps) {
    const radial = 6;
    const CIRCUMFERENCE = 2 * radial * Math.PI;

    const strokeDasharray = typeof progress === "number" ? `${CIRCUMFERENCE * progress / 100} ${CIRCUMFERENCE * (100 - progress) / 100}` : "var(--progress-indicator-icon-stroke-dash-array)";

    return (
        <svg class={classname(styles.progressIndicatorIcon, cssClass)} width="16" height="16" version="1.1">
            <circle cx="8" cy="8" r={radial}/>
            <circle cx="8" cy="8" r={radial} stroke-dasharray={strokeDasharray}/>
        </svg>
    );
}
